import { useQuery } from "@apollo/client/react";

import { switchQuery } from "./switchBookingQuery";

export const useSwitchCandidates = (bookingNo: number) => {
  const { data, error, loading } = useQuery(switchQuery, {
    fetchPolicy: "network-only",
    errorPolicy: "none",
    variables: { bookingNo },
  });

  return {
    candidates: data?.viewer.bookings.forSwitch.bookings ?? [],
    booking: data?.viewer.bookings.byBookingNo,
    error,
    loading,
  };
};
